import styled, { css } from 'styled-components'

import { fontSize } from 'ui/themes/utils'

export const ProductImage = styled.div`
  float: left;

  width: 250px;

  @media (max-width: 534px) {
    width: 100%;
    float: none;
  }
`

export const MainImage = styled.div`
  max-height: 100%;
  max-width: 100%;

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;

  visibility: hidden;

  ${({ visible }) => visible && css`
    visibility: visible;
  `}
`

export const MainImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 250px;
  height: 250px;

  position: relative;

  cursor: zoom-in;

  ${({ magnify }) => magnify && css`
    cursor: zoom-out;
  `}

  ${({ canMagnify }) => !canMagnify && css`
    cursor: default;
  `}

  @media (max-width: 534px) {
    width: 100%;
  }

  @media (max-height: 550px) {
    height: 200px;
  }
`

export const GalleryImages = styled.div`
  position: absolute;

  left: ${({ offset }) => offset || 0};
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: left 0.3s ease-in-out;
`

export const GalleryImagesContainer = styled.div`
  position: relative;
  overflow: hidden;
`

export const GalleryImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 5px !important;

  overflow: hidden;

  border: 1px solid transparent !important;

  &:hover {
    border: 1px solid ${({ brandingColor }) => brandingColor};
    cursor: pointer;
  }

  ${({ selected }) => selected && css`
    border: 1px solid ${({ brandingColor }) => brandingColor} !important;
  `}
`

export const GalleryImage = styled.img`
  max-height: 100%;
  max-width: 100%;
`

export const Controls = styled.div`
  font-size: ${fontSize('md')};

  transition: opacity 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  ${({ disabled }) => disabled && css`
    opacity: 0.6;
    cursor: initial;
    pointer-events: none;
  `}
`

export const Gallery = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 10px !important;

  ${({ size, offset }) => css`
    ${GalleryImagesContainer} {
      /* 5 = gap between images */
      width: ${((size + 5) * 3) + 5}px;
      height: ${size}px;
    }

    ${GalleryImageContainer} {
      height: ${size}px;
      width: ${size}px;
    }

    ${GalleryImages} {
      left: -${offset * (size + 5)}px;
    }
  `}
`
